import { IShopsListProps } from './shops-list.models';
import { useStyles } from './shops-list.styles';
import { ensureAbsoluteUrl } from '../../../../../utils';

export const ShopsList = ({ shops }: IShopsListProps): JSX.Element => {
  const classes = useStyles();

  return (
    <ul
      className={classes.shopList}
      data-testid="online-shops-list"
    >
      {shops.map(({ name, website }, index) => (
        <li
          key={index}
          data-testid="online-shops"
          className={classes.shopItem}
        >
          <a
            className={classes.link}
            href={website ? ensureAbsoluteUrl(website) : '#'}
            target="_blank"
          >
            {name}
          </a>
        </li>
      ))}
    </ul>
  );
};
